module.exports = __webpack_public_path__ + "img/universidad-de-la-republica-uruguay-cor.18d05f43.png";